declare global {
    interface Window {
        language: string,
        typesense_environment: string,
        translations: Array<string>,
        Splide: any;
        Pinia: any;
        Alpine: any;
    }
}

// import css
import '~/css/app.css'
// Import full Splide theme CSS for arrows and styling
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import { getStockInfo } from '~/js/composables/stock';

// import icons
import '~/js/assets/icons.js'

// alpine
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse';

window.Alpine = Alpine
window.Splide = Splide
Alpine.plugin(focus)
Alpine.plugin(collapse);

const navigation = () => ({
    activeSubNav: '',
    activeSubSubNav: '',
    screenWidth: 0,
    showSharesBanner: true,
    showLanguageNavigation: false,
    showMobileNavigation: false,
    timeout: null as number | null,
    
    debounce(func: () => void, wait: number, breakpoint: number|null = null) {
        if (breakpoint && window.innerWidth < breakpoint) {
            return
        }

        const later = () => {
            this.timeout = null
            func()
        }

        if (this.timeout) {
            clearTimeout(this.timeout)
        }

        this.timeout = window.setTimeout(later, wait) as unknown as number
    },
    
    setBack(level) {
        switch (level) {
            case 1:
                this.activeSubSubNav = ''
                break
        }
    },
    
    getShowSubnavs(level, title = null) {
        let check = false
        
        switch (level) {
            case 1:
                check = this.activeSubNav == title;
                break;
            case 2:
                check = this.activeSubSubNav == title;
                break;
        }
        
        return check;
    },

    toggleMobileNavigation() {
        this.showMobileNavigation = !this.showMobileNavigation

        if (!this.showLanguageNavigation) {
            this.activeSubNav = ''
            this.activeSubSubNav = ''
        }

        if (this.showMobileNavigation) {
            document.body.classList.add('overflow-hidden')
        } else {
            document.body.classList.remove('overflow-hidden')
        }
    },

    setBannerVisibility() {
        this.showSharesBanner = window.scrollY < 30
    },

    init() {
        this.screenWidth = window.innerWidth

        this.setBannerVisibility()
        
        window.addEventListener('resize', () => {
            this.screenWidth = window.innerWidth
        })
        
        window.addEventListener('scroll', () => {
            this.setBannerVisibility()
        })

        // this.$watch('activeSubSubNav', (value, oldValue) => {
        //     console.log('activeSubSubNav changed from', oldValue, 'to', value);
        // });
    }
})

Alpine.data('navigation', navigation);
Alpine.start();

// Initialize Splide
document.addEventListener('DOMContentLoaded', () => {
    const splides = document.querySelectorAll('[data-splide]');
    splides.forEach((el) => {
        const optionsRaw = el.getAttribute('data-splide');
        const options = optionsRaw ? JSON.parse(optionsRaw) : {};

        new Splide(el, {
            ...options,
        }).mount();
    });
});

// Warehouse App
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const main = async () => {
    getStockInfo()
    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate)
    window.Pinia = pinia
}

// Execute async function
main().then(() => {
    console.log()
})

// Warehouse Gallery
import './warehouse-gallery.js';

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}
